import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Skeleton from "./common/Skeleton";
import { tEnum } from "../../config/translations";
import {
    fetchApplicationSettings,
    patchApplicationSettings,
} from "../../core/api/ApplicationSettingsApi";
import "../styles/ApplicationVisibilityPanel.css";

export default function ApplicationVisibilityPanel() {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [settings, setSettings] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const data = await fetchApplicationSettings();
            setSettings(data);
        } catch (e) {
            console.error(e);
            toast.error("Başvuru ayarları yüklenemedi");
            setSettings(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const handleToggle = async () => {
        if (!settings?.hasDefaultTerm) {
            toast.warning("Önce Kurs Yönetimi'nden bir dönemi aktif yapın");
            return;
        }
        const next = !settings.isApplicationOpen;
        setSaving(true);
        try {
            const res = await patchApplicationSettings(next);
            setSettings(res?.data ?? { ...settings, isApplicationOpen: next });
            toast.success(res?.message || (next ? "Form açıldı" : "Form kapatıldı"));
        } catch (e) {
            toast.error(e?.response?.data?.message || "Güncellenemedi");
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="app-visibility-panel">
                <Skeleton height={52} />
            </div>
        );
    }

    const open = !!settings?.isApplicationOpen;
    const hasTerm = !!settings?.hasDefaultTerm;

    return (
        <div className={`app-visibility-panel ${open ? "is-open" : "is-closed"}`}>
            <div className="app-visibility-info">
                <span className="app-visibility-label">Public başvuru formu</span>
                {hasTerm ? (
                    <span className="app-visibility-meta">
                        Aktif dönem: <strong>{settings.name}</strong>
                        {" · "}
                        {tEnum("TERM_TYPE", settings.type)}
                    </span>
                ) : (
                    <span className="app-visibility-meta app-visibility-warn">
                        Aktif dönem yok — önce bir dönemi aktif yapın
                    </span>
                )}
            </div>

            <div className="app-visibility-actions">
                <span className={`app-visibility-status ${open ? "open" : "closed"}`}>
                    {open ? "Açık" : "Kapalı"}
                </span>
                <button
                    type="button"
                    className={`app-visibility-toggle ${open ? "on" : "off"}`}
                    role="switch"
                    aria-checked={open}
                    disabled={saving || !hasTerm}
                    onClick={handleToggle}
                    title={
                        hasTerm
                            ? open
                                ? "Formu kapat"
                                : "Formu aç"
                            : "Aktif dönem gerekli"
                    }
                >
                    <span className="app-visibility-knob" />
                </button>
            </div>
        </div>
    );
}
